import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { BrowserPlatformService } from 'src/@services/browser-platform.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { ColumnsHeader, TableId } from 'src/models/commomnModel.model';
import { Program } from 'src/models/program.model';
import { responseMessageStatus, ResponseStatus } from '../../enum';
import { applyProgramVisibilityCascade } from '../../program-period-visibility-cascade';

@Component({
  selector: 'app-manage-programs',
  templateUrl: './manage-programs.component.html',
  styleUrls: ['./manage-programs.component.scss'],
  standalone: false,
})
export class ManageProgramsComponent implements OnInit {
  isDataLoaded = false;
  searchText: string = '';
  selectedFilter: number = 2;
  page: number = 1;
  pageSize: number = 100;
  sortBy: string = 'desc';
  sortField: string = 'startYear';
  apiProgramsData: Program[] = [
    {
      label: '',
      isDefault: true,
      isVisible: true,
      endYear: 1,
      endMonth: '',
      startYear: '',
      startMonth: 1,
      linked: 1,
      shortEndMonth: '',
      shortStartMonth: '',
    },
  ];
  filterByStatus: number = 2;
  totalRecords = 100;
  isVisibleProgramDrawer: boolean = false;
  showActions: boolean = true;
  canEditProgram: boolean = false;
  canDeleteProgram: boolean = false;
  @Input() isInvestmentModal: string;
  @Output() hideShowProgramDrawer = new EventEmitter();
  @Output() newAddedProgram = new EventEmitter();
  @Output() addUpdateProgram = new EventEmitter();
  selectedData: Program;
  siteId: string;
  radioValue: string = 'A';
  deleteConfirmVisisble: boolean = false;
  loading: boolean = false;
  timer = null;
  oldSearchText: string = '';
  @ViewChild('apiProgramsDataTable', { static: false })
  apiProgramsDataTable: TableId;
  subscription: Subscription[] = [];
  canAddProgram: boolean = false;

  colsPrograms: ColumnsHeader[] = [
    {
      title: 'Program Label',
      width: '180',
      sortDir: null,
    },
    {
      title: 'Start Date',
      width: '150',
      sortDir: null,
    },
    {
      title: 'End Date',
      width: '150',
      sortDir: null,
    },
    {
      title: 'Default',
      width: '100',
      sortDir: null,
    },
    {
      title: 'Status',
      width: '100',
      sortDir: null,
    },
    {
      title: 'Linked',
      width: '100',
      sortDir: null,
    },
    {
      title: 'Action',
      width: '80px',
      sortDir: null,
    },
  ];
  constructor(
    public _cS: CommonService,
    private _iS: InnerPagesService,
    private route: ActivatedRoute,
    private cdref: ChangeDetectorRef,
    private browserPlatformService: BrowserPlatformService
  ) { }

  ngOnInit(): void {
    //to hide actions and linked column
    // if (this.isInvestmentModal == 'invest') {
    // this.showActions = false;
    // }    
    //get site id for URL
    this.siteId = this.route.snapshot.paramMap.get('siteId');

    // get permission details of current user role of users

    this.canAddProgram = this._iS.canAccessProgramsTags().canAddProgramTag;
    this.canEditProgram = this._iS.canAccessProgramsTags().canEditProgramTag;
    this.canDeleteProgram =
      this._iS.canAccessProgramsTags().canDeleteProgramTag;

    this.subscription.push(
      this._cS.programPeiord.subscribe((res: any) => {
        if (res != null) {
          this.addProgramToList(res);
        }
      }),
      this._cS.searchProgramPeriod.subscribe((res: any) => {
        if (res) {
          this.seachProgram(res.event, res.searchText);
        }
      }),
      this._cS.filterProgramByStatus.subscribe((res: any) => {
        if (res != null) {
          this.filterProgramPeriod(res);
        }
      })
    );
    this.getAllPrograms();
  }

  addProgramToList(res: any) {
    const existingData = this.apiProgramsData.find(
      (program: any) => program.id === res.id
    );
    if (existingData) {
      existingData.id = res.id;
      existingData.label = res.label;
      existingData.startMonth = res.startMonth;
      existingData.endMonth = res.endMonth;
      existingData.shortStartMonth = res.shortStartMonth;
      existingData.shortEndMonth = res.shortEndMonth;
      existingData.startYear = res.startYear;
      existingData.endYear = res.endYear;
      existingData.isDefault = res.isDefault;
      existingData.isVisible = res.isVisible;
      existingData.linked = res.linked;

      this.addUpdateProgram.emit({ isNewData: false, data: existingData });
    } else {
      if (this.apiProgramsData?.length > 99) {
        this.getAllPrograms();
      }
      this.apiProgramsData?.splice(1, 0, res);
      if (res.isDefault) {
        this.radioValue = res.id;
      }
      this.apiProgramsData = [...this.apiProgramsData];
      this.addUpdateProgram.emit({ isNewData: true, data: res });
    }
  }
  filterProgramPeriod(status: any) {
    this.page = 1;
    this.filterByStatus = status;
    this.selectedFilter = status;
    this.getAllPrograms();
  }
  seachProgram(event: any, searchText: any) {
    this.searchText = searchText;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.page = 1;
          this.getAllPrograms();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.getAllPrograms();
        }
      }
    }
  }
  onResize({ width }: NzResizeEvent, col: string): void {
    this.colsPrograms = this.colsPrograms.map((e) =>
      e.title === col ? { ...e, width: `${width}px` } : e
    );
  }
  //get all programs for current site
  getAllPrograms() {
    this.isDataLoaded = true;
    const requestBody = {
      searchText: this.searchText,
      sortField: this.sortField,
      sortBy: this.sortBy,
      page: this.page,
      pageSize: this.pageSize,
      filterByStatus: this.filterByStatus,
      siteId: this.siteId,
    };
    this._iS.getAllPrograms(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isDataLoaded = false;
        this.apiProgramsData = response.result.records;
        this.totalRecords = response.result.totalRecord;
        const defaultProgram = this.apiProgramsData.find(
          (program: any) => program.isDefault == true
        );
        if (defaultProgram) {
          this.radioValue = defaultProgram.id;
        }
      } else {
        this.isDataLoaded = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  navigateToActivity(data: any) {
    this.browserPlatformService.openInNewTab(
      '/paybev/' +
      this.siteId +
      '/activity-detailed?program=' +
      data.id +
      '&startMonth=' +
      data.startMonth +
      '&startYear=' +
      data.startYear
    );
  }

  //from table make program as default
  makeProgramDefault(event: any) {
    const formData = new FormData();
    formData.set('Id', event);
    formData.set('siteId', this.siteId);
    this._iS.makeProgramDefault(formData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        const program = this.apiProgramsData.find(
          (item: any) => item.id == event
        );
        this.radioValue = program.id;
        this.apiProgramsData.map((x: any) => (x.isDefault = false));
        program.isDefault = true;
        this.newAddedProgram.emit({ data: response.result });
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  // from table set program as visible or hidden
  updateProgramVisible(program: Program) {
    const previousVisibility = !program.isVisible;
    const programId = program.id || '';

    const formData = new FormData();
    formData.set('Id', programId);
    this._iS.updateProgramVisible(formData).subscribe((response: any) => {
      if (response.responseStatus !== ResponseStatus.success) {
        // Revert switch in UI when API update fails.
        program.isVisible = previousVisibility;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
        return;
      }

      const result = response.result;
      const anchorVisible =
        result?.isVisible ?? result?.IsVisible ?? program.isVisible;
      program.isVisible = anchorVisible;

      const visibilityBefore = new Map(
        this.apiProgramsData.map((p) => [p.id, p.isVisible])
      );
      applyProgramVisibilityCascade(
        this.apiProgramsData,
        programId,
        anchorVisible
      );
      this.apiProgramsData = [...this.apiProgramsData];

      for (const row of this.apiProgramsData) {
        const visibilityChanged = visibilityBefore.get(row.id) !== row.isVisible;
        if (visibilityChanged || row.id === programId) {
          this.newAddedProgram.emit({ data: { ...row } });
        }
      }

      this.cdref.detectChanges();
      this._cS.displayMessage(
        responseMessageStatus.success,
        response.message || 'Program visibility updated successfully.'
      );
    });
  }
  //pagination
  onQueryParamsChange(event: any) {
    this.page = event;
    this.getAllPrograms();
    this.apiProgramsDataTable.elementRef.nativeElement
      .getElementsByClassName('ant-table-body')[0]
      .scrollTo(0, 0);
  }
  //to show user drawer
  // showProgramDrawer(event: any): void {
  //   this.isVisibleProgramDrawer = true;
  //   this.hideShowProgramDrawer.emit({
  //     show: this.isVisibleProgramDrawer,
  //     data: event,
  //   });
  // }

  //showDeleteConfirm
  showDeleteConfirm(data: any) {
    this.deleteConfirmVisisble = true;
    this.selectedData = data;
  }

  //close delete confirmation modal
  handleCancel() {
    this.deleteConfirmVisisble = false;
  }

  //search user
  searchPorgram(event: any) {
    this._cS.searchProgramPeriod.next({
      event: event,
      searchText: this.searchText,
    });
  }

  //filter by active/inactive
  stautusFilter(status: any) {
    this._cS.filterProgramByStatus.next(status);
  }

  //to show user drawer
  showProgramDrawer(event: any): void {
    this.isVisibleProgramDrawer = true;
    if (event) {
      this.selectedData = event;
    } else {
      this.selectedData = null;
    }
  }
  //hide modal and reflect changes push or update data in listing
  hideProgramDrawer(event: any) {
    this.isVisibleProgramDrawer = event.hide;

    if (event.data != null) {
      this.page = 1;
      this.getAllPrograms();
      this._cS.programPeiord.next(event.data);
    }
  }

  //delete program
  deleteProgram() {
    this.loading = true;
    this._iS.deleteProgram(this.selectedData.id).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.deleteConfirmVisisble = false;
        this.loading = false;
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
        if (this.totalRecords > 100) {
          if (this.apiProgramsData.length <= 1) {
            this.page = this.page - 1;
          }
          this.getAllPrograms();
        } else {
          this.apiProgramsData = this.apiProgramsData.filter(
            (data: any) => data.id !== this.selectedData.id
          );
        }
      } else {
        this.loading = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
        this.deleteConfirmVisisble = false;
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.forEach((s) => s.unsubscribe());
    this._cS.programPeiord.next(null);
    this._cS.filterProgramByStatus.next(null);
    this._cS.searchProgramPeriod.next(null);
  }
  // to avoid expression ng-zorro error
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
